'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const products = [
{
  id: 1,
  category: 'Structural',
  title: 'NeXSYS Structural Nodes',
  badge: '(Patent Pending)',
  desc: 'Precision-engineered connection NODES for multi-directional bolted assembly.',
  img: "/assets/images/structural-node-1774075551051.png",
  alt: 'NeXSYS Structural Nodes (Patent Pending)',
  comingSoon: false
},
{
  id: 2,
  category: 'Structural',
  title: 'NeXSYS Column & S Beam System',
  badge: '(Patent Pending)',
  desc: 'Standardized steel Columns & Beams with integrated connection points for rapid assembly. Achieving long spans and high ceiling heights.',
  img: "/assets/images/universal-beam-1774075825649.png",
  alt: 'NeXSYS Column & S Beam System (Patent Pending)',
  comingSoon: false
},
{
  id: 3,
  category: 'Structural',
  title: 'NeXSYS Full Bracing',
  badge: '(Patent Pending)',
  desc: 'Full Cross bracing system allowing for connections to walls, ceiling and floor Skid. Total Bracing capability.',
  img: "/assets/images/full-bracing-BNV7Z_WA-1774075942667.png",
  alt: 'NeXSYS Full Bracing (Patent Pending)',
  comingSoon: false
},
{
  id: 4,
  category: 'Structural',
  title: 'NeXSYS Full Bracing',
  badge: '',
  desc: 'Bracing and Stiffing options to suite Designs.',
  img: "/assets/images/bracing-options-DWwW8shW-1774075975085.png",
  alt: 'NeXSYS Full Bracing',
  comingSoon: false
},
{
  id: 5,
  category: 'Structural',
  title: 'NeXSYS Roof NODE & Panel',
  badge: '(Patent Pending)',
  desc: 'Pitched Roof Panels, for rapid Installation, no truss system.',
  img: "/assets/images/roof-panel-node-DzIRGP8s-1774076068863.png",
  alt: 'NeXSYS Roof NODE & Panel (Patent Pending)',
  comingSoon: false
},
{
  id: 6,
  category: 'Bathroom POD',
  title: 'NeXSYS Bathroom Floor System',
  badge: '(Patent Pending)',
  desc: 'Cold formed custom Bathroom Pod Frame with floor base pre waterproofed.',
  img: "/assets/images/bathroom-pod-frame-CYTaJ8xi-1774076157190.png",
  alt: 'NeXSYS Bathroom Floor System (Patent Pending)',
  comingSoon: false
},
{
  id: 7,
  category: 'Structural',
  title: 'NeXSYS Stairs Systems',
  badge: '',
  desc: 'Steel Structure Boltable (Coming Soon) - Flexible Module stair design, easy of assembly and configuration.',
  img: "/assets/images/smart-mep-hub-OIAHQyCq-1774076235181.png",
  alt: 'NeXSYS Stairs Systems',
  comingSoon: true
},
{
  id: 8,
  category: 'Data Centers',
  title: 'Data Centers',
  badge: '',
  desc: 'Floor Skid Panel - High-performance Heavy Loading floor with optional 3D Ready for use.',
  img: "/assets/images/acoustic-wall-panel-_5qUVIrY-1774076525958.png",
  alt: 'Data Centers',
  comingSoon: false
},
{
  id: 9,
  category: 'MEP',
  title: 'NeXSYS MEP Wall Inserts',
  badge: '',
  desc: 'Various Engineered templets for pre installed MEP packs, electrical, Mechanical and plumbing.',
  img: "/assets/images/mep-wall-inserts-CaTRF6Xw-1774076553556.png",
  alt: 'NeXSYS MEP Wall Inserts',
  comingSoon: false
},
{
  id: 10,
  category: 'Structural',
  title: 'NeXSYS Joists Support and Bracing',
  badge: '',
  desc: 'Various Elements for the joists from bracing to MEP Support to other.',
  img: "/assets/images/joists-support-bracing-BjXZff0k-1774076650357.png",
  alt: 'NeXSYS Joists Support and Bracing',
  comingSoon: false
},
{
  id: 11,
  category: 'Factory System',
  title: 'NeXSYS Assembly Jig',
  badge: '',
  desc: 'Static Factory assembly Jig for floor and ceiling skids.',
  img: "/assets/images/assembly-jig-au7b9Njy-1774076730124.png",
  alt: 'NeXSYS Assembly Jig',
  comingSoon: false
}];


const categories = ['All', 'Structural', 'Bathroom POD', 'Data Centers', 'MEP', 'Factory System'];

export default function ProductsPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All' ?
  products :
  products?.filter((p) => p?.category === activeCategory);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative min-h-[40vh] flex items-end pb-16 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="/assets/images/93eb2158-48d3-4052-a385-e1620c6977f7_edited-1774455381275.jpg"
              alt="Modular construction with crane"
              className="w-full h-full object-cover object-top"
              style={{ top: '-50px', position: 'relative' }} />
            
            <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, hsla(215, 28%, 10%, 0.7) 0%, hsla(207, 52%, 25%, 0.8) 100%)' }} />
          </div>
          <div className="relative container mx-auto container-padding pt-20">
            <div className="max-w-3xl">
              <h1 className="text-hero lg:text-hero-lg font-heading font-bold text-white mb-6">
                Products
              </h1>
              <p className="text-xl text-white/80 leading-relaxed">
                Explore our comprehensive range of structural components, MEP integration systems, cladding solutions, and finish systems.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Tabs */}
        <section className="py-8 bg-card border-b border-border">
          <div className="container mx-auto container-padding">
            <div className="flex flex-wrap gap-2">
              {categories?.map((cat) =>
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeCategory === cat ?
                'bg-primary text-white shadow-md' :
                'bg-nexsys-surface text-muted-foreground hover:bg-nexsys-light-gray'}`
                }>
                
                  {cat}
                </button>
              )}
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="section-padding">
          <div className="container mx-auto container-padding">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filtered?.map((product) =>
              <div
                key={product?.id}
                className="bg-card rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1 border border-border">
                
                  <div className="relative aspect-[4/3] overflow-hidden bg-nexsys-surface">
                    <img
                    src={product?.img}
                    alt={product?.alt}
                    className="w-full h-full object-cover" />
                  
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs font-semibold bg-primary/10 text-primary px-2 py-1 rounded-full">
                        {product?.category}
                      </span>
                      {product?.comingSoon &&
                    <span className="text-xs font-semibold bg-banana/20 text-banana-foreground px-2 py-1 rounded-full">
                          Coming Soon
                        </span>
                    }
                    </div>
                    <h3 className="font-heading font-bold text-base text-foreground mb-1">
                      <span className="text-nexsys-brand">NeXSYS</span>{' '}
                      {product?.title?.replace('NeXSYS ', '')}
                      {product?.badge &&
                    <span className="text-muted-foreground font-normal text-sm"> {product?.badge}</span>
                    }
                    </h3>
                    <p className="text-muted-foreground text-sm">{product?.desc}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section-padding bg-gradient-dark">
          <div className="container mx-auto container-padding text-center">
            <h2 className="text-section font-heading font-bold text-white mb-4">
              Need Custom Solutions?
            </h2>
            <p className="text-white/70 text-lg mb-8 max-w-2xl mx-auto">
              Our engineering team works with partners to develop custom components tailored to specific project requirements.
            </p>
            <Link
              href="/contact"
              className="inline-flex items-center gap-2 bg-banana text-banana-foreground font-semibold px-8 py-4 rounded-lg hover:bg-banana/90 transition-all duration-200 hover:-translate-y-0.5 shadow-md hover:shadow-lg">
              
              Discuss Your Project
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>);

}